import React, { useState, useEffect } from 'react';
import Summary from './Summary/Summary';
import * as Constants from '../../../requests/URLConstants';
import callPostApi from "../../../requests/PostRequests";
import moment from 'moment';
import "@carbon/charts/styles.css";
import * as DashboardUtils from '../DashboardUtils.js';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants';
import DashboardSideNavFilter from '../DashoardSideNavFilter';
import DashboardLineChart from "../DashboardLineChart";
import DashboardTable from "../DashboardTable";
import * as ProcessesTables from './tableHeaders';
import { Breadcrumb, BreadcrumbItem, InlineLoading, TableToolbar, TableToolbarContent, ContentSwitcher, Switch } from 'carbon-components-react';
import Pluralize from 'pluralize';

require('moment-timezone');
require("./_processes.scss");

const Processes = (props) => {

    const [processesSummaryLoading, setProcessesSummaryLoading] = useState(true);
    const [orderProcessingData, setOrderProcessingData] = useState([]);
    const [automationDowntimeLoading, setAutomationDowntimeLoading] = useState(false);
    const [automationDowntimeData, setAutomationDowntimeData] = useState([]);
    const [navMenu, setNavMenu] = useState([]);
    const [errorTableLoading, setErrorTableLoading] = useState(false);
    const [selectedNavItemArray, setSelectedNavItemArray] = useState([]);
    const [ordersReceived, setOrdersReceived] = useState();
    const [ordersToBeProcessed, setOrdersToBeProcessed] = useState();
    const [avgOrderProcessingTime, setAvgOrderProcessingTime] = useState();
    const [expectedTimeOfCompletion, setExpectedTimeOfCompletion] = useState();
    const [ordersReceivedLoading, setOrdersReceivedLoading] = useState(true);
    const [avgOrderProcessingTimeLoading, setAvgOrderProcessingTimeLoading] = useState(true);
    const [orderProcessingLoading, setOrderProcessingLoading] = useState(true);
    const [ordersToBeProcessedLoading, setOrdersToBeProcessedLoading] = useState(true);
    const [processesSummary, setProcessesSummary] = useState([]);
    const [sideNavLoading, setSideNavLoading] = useState(false);
    const [humanErrorCount, setHumanErrorCount] = useState(0);
    const [machineErrorCount, setMachineErrorCount] = useState(0);
    const [humanErrorLoading, setHumanErrorLoading] = useState(false);
    const [machineErrorLoading, setMachineErrorLoading] = useState(false);
    const [orderAnomaliesLoading, setOrderAnomaliesLoading] = useState(false);
    const [orderAnomaliesData, setOrderAnomaliesData] = useState([]);
    const [orderAnomaliesTableHeaders, setOrderAnomaliesTableHeaders] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [SelectedView, setSelectedView] = useState('HumanError');
    const [selectedMenu, setSelectedMenu] = useState();
    const [pendingOrdersToBeProcessed, setPendingOrdersToBeProcessed] = useState(0);
    const [exceptionOrdersToBeProcessed, setExceptionOrdersToBeProcessed] = useState(0);

    const processesError = [{
        id: '1',
        title: DashboardConstants.HumanError,
        value: humanErrorCount,
        target: Number((humanErrorCount * 100) / (machineErrorCount + humanErrorCount)) ? ((humanErrorCount * 100) / (machineErrorCount + humanErrorCount)).toFixed(2) : 0,
        showPercent: true,
        icon: "HumanError"
    }, {
        id: '1',
        title: DashboardConstants.MachineError,
        value: machineErrorCount,
        target: Number((machineErrorCount * 100) / (machineErrorCount + humanErrorCount)) ? ((machineErrorCount * 100) / (machineErrorCount + humanErrorCount)).toFixed(2) : 0,
        showPercent: true,
        icon: "MachineError"
    }];

    const [errorTableData, setErrorTableData] = useState([{
        orderId: "1",
        orderNumber: "56",
        error: "You got this error",
        incidentNumber: "INC453",
        assignedTo: "Xyz"
    },
    {
        orderId: "1",
        orderNumber: "56",
        error: "You got this error",
        incidentNumber: "INC453",
        assignedTo: "Xyz"
    }]);

    const getNavDefaultItemArray = () => {
        let defaultItemArray = [];
        if (navMenu.length) {
            let level1 = navMenu[0]["3"].buckets[0];
            defaultItemArray.push(navMenu[0].key)
            if (level1) {
                defaultItemArray.push(level1.key);
                let level2 = level1["4"].buckets[0];
                if (level2) {
                    defaultItemArray.push(level2.key);
                    let level3 = level2["5"].buckets[0];
                    if (level3) {
                        defaultItemArray.push(level3.key);
                        let level4 = level3["6"].buckets[0];
                        if (level4) {
                            defaultItemArray.push(level4.key);
                        }
                    }
                }
            }
        }
        return defaultItemArray;
    };

    useEffect(() => {
        getBizOpsCBMTree(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    useEffect(() => {
        if (navMenu.length) {
            let navDefaultItemArray = getNavDefaultItemArray();
            let KeyFound = findNestedKey(navMenu, "key", props.selectedProcess.length > 0 ? props.selectedProcess[props.selectedProcess.length - 1] : navDefaultItemArray[navDefaultItemArray.length - 1])

            if (KeyFound && props.selectedProcess.length > 0) {
                props.handleSelectedProcess(props.selectedProcess);
                setSelectedNavItemArray(props.selectedProcess);
                reloadData(props.selectedProcess);
            }
            else {
                props.handleSelectedProcess(navDefaultItemArray);
                setSelectedNavItemArray(navDefaultItemArray);
                reloadData(navDefaultItemArray);
            }
        }
    }, [navMenu]);

    function findNestedKey(entireObj, keyToFind, valToFind) {
        let foundObj;
        JSON.stringify(entireObj, (_, nestedValue) => {
            if (nestedValue && nestedValue[keyToFind] === valToFind) {
                foundObj = nestedValue;
            }
            return nestedValue;
        });
        return foundObj;
    };

    const prepareSummaryData = () => {
        let summary = [{
            id: '1',
            title: `${keyword} ${DashboardConstants.Received}`,
            value: ordersReceived ? ordersReceived.toString() : 0,
            showPercent: false,
            icon: "Tile1"
        }, {
            id: '2',
            title: `${Pluralize(keyword)} ${DashboardConstants.YetToBeProcessed}`,
            value: ordersToBeProcessed ? ordersToBeProcessed.toString() : 0,
            showPercent: false,
            icon: "Tile2",
            showOrders: true,
            orderValues: { pending: pendingOrdersToBeProcessed || 0, exceptions: exceptionOrdersToBeProcessed || 0 }
        }, {
            id: '3',
            title: `${DashboardConstants.Average} ${keyword} ${DashboardConstants.ProcessingTime}`,
            value: avgOrderProcessingTime ? avgOrderProcessingTime.toString() : '00:00',
            showPercent: false,
            icon: "Tile3",
            showHoursMinutes: true
        }, {
            id: '4',
            title: DashboardConstants.ExpectedTimeOfCompletion,
            value: expectedTimeOfCompletion ? expectedTimeOfCompletion.toString() : '00.00',
            showPercent: false,
            icon: "Tile4",
            showHoursMinutes: true
        }];
        return summary;
    };

    useEffect(() => {
        setProcessesSummaryLoading(true);
        if (!ordersToBeProcessedLoading && !ordersReceivedLoading && !avgOrderProcessingTimeLoading && keyword !== "") {
            let formattedData = prepareSummaryData();
            setProcessesSummary(formattedData);
            setProcessesSummaryLoading(false);
        }
    }, [ordersToBeProcessedLoading, ordersReceivedLoading, avgOrderProcessingTimeLoading, keyword]);

    const reloadData = (selectedNavItemArray) => {
        setSelectedNavItemArray(selectedNavItemArray);
        props.handleSelectedProcess(selectedNavItemArray);
        if (selectedNavItemArray[selectedNavItemArray.length - 1]) {
            getOrderAnomalies(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getOrdersToBeProcessed(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getOrderReceivedTile(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getOrderAvgProcessingTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getOrderProcessingTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getDownTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getMachineErrorCount(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
            getHumanErrorCount(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
        }
        setSelectedMenu(selectedNavItemArray.at(0));
    };

    useEffect(() => {
        if (selectedNavItemArray[selectedNavItemArray.length - 1]) {
            getOrderProcessingTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
        }
    }, [keyword]);

    useEffect(() => {
        if (selectedNavItemArray[selectedNavItemArray.length - 1]) {
            getOrderAnomalies(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedNavItemArray[selectedNavItemArray.length - 1]);
        }
    }, [SelectedView]);

    function getTimeDifferencefromSeconds(seconds) {
        seconds = isNaN(Number(seconds)) ? 0 : Number(seconds);
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds % 3600) / 60);

        let hourDisplay = hours > 9 ? hours : `0${hours}`
        let minuteDisplay = minutes > 9 ? minutes : `0${minutes}`
        let displayValue = seconds > 59 ? `${hourDisplay}:${minuteDisplay}` : "00:00"
        //console.log('getTimeDifferencefromSeconds', displayValue)

        return displayValue;
    }

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "resource": dashboardFilterSelectionsAutomation.resource,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace,
                "automataName": automataName
            };
        }
        return bodyJSON;
    };

    const prepareOrderProcessingTrendData = (resp) => {
        let data = [];
        let obj = {};
        if (resp) {
            let buckets = resp.aggregations["Time"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                obj = {
                    group: `${keyword} Processed`,
                    date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                    value: (buckets[i].Completed_orders.value).toFixed(2)
                }
                data.push(obj);
            }
        }
        return data;
    };

    const getOrderProcessingTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        setOrderProcessingLoading(true);
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETORDERPROCESSINGTREND, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareOrderProcessingTrendData(resp);
                    setOrderProcessingData(formattedData);
                    setOrderProcessingLoading(false);
                })
                .catch((error) => {
                    setOrderProcessingLoading(false);
                });
        }
    };

    const getBizOpsCBMTree = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        setSideNavLoading(true);
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETBIZOPSCBMTREE, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    setSideNavLoading(false);
                    setNavMenu(resp.aggregations["2"].buckets);
                })
                .catch((error) => {
                    setSideNavLoading(false);
                });
        }
    };

    const getOrderAvgProcessingTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAvgOrderProcessingTimeLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETORDERAVGPROCESSINGTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    let averageOrderProcessingTime = getTimeDifferencefromSeconds(resp.avgProcessingTimeInSeconds);
                    setAvgOrderProcessingTime(averageOrderProcessingTime);
                    setAvgOrderProcessingTimeLoading(false);
                })
                .catch((error) => {
                    setAvgOrderProcessingTimeLoading(false);
                });
        }
    };

    const getOrderReceivedTile = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setOrdersReceivedLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETORDERRECEIVEDTILE, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    setOrdersReceived(resp.ordersReceived);
                    setOrdersReceivedLoading(false);
                })
                .catch((error) => {
                    setOrdersReceivedLoading(false);
                });
        }
    };

    const getOrdersToBeProcessed = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setOrdersToBeProcessedLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETORDERSTOBEPROCESSEDTILE, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    let expectedTimeOfCompletionValue = getTimeDifferencefromSeconds(resp.standardExecutionTime);
                    setOrdersToBeProcessed(resp.ordersToBeProcessed);
                    setExpectedTimeOfCompletion(expectedTimeOfCompletionValue);
                    setPendingOrdersToBeProcessed(resp.pendingOrdersToBeProcessed);
                    setExceptionOrdersToBeProcessed(resp.exceptionOrdersToBeProcessed);
                    setOrdersToBeProcessedLoading(false);
                })
                .catch((error) => {
                    setOrdersToBeProcessedLoading(false);
                });
        }
    };

    const prepareDowntimeData = (resp) => {
        let data = [];
        let obj = {};
        if (resp) {
            let buckets = resp.aggregations["Time"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                obj = {
                    group: "Downtime",
                    date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                    value: buckets[i].downtime.value ? ((buckets[i].downtime.value) / 60).toFixed(2) : 0
                }
                data.push(obj);
            }
        }
        return data;
    };

    const getDownTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        let formattedData = [];
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAutomationDowntimeLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETDOWNTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareDowntimeData(resp);
                    setAutomationDowntimeData(formattedData);
                    setAutomationDowntimeLoading(false);
                })
                .catch((error) => {
                    setAutomationDowntimeLoading(false);
                });
        }
    };

    const getHumanErrorCount = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setHumanErrorLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETHUMANERRORCOUNT, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    setHumanErrorLoading(false);
                    setHumanErrorCount(resp.hits.total.value);
                })
                .catch((error) => {
                    setHumanErrorLoading(false);
                });
        }
    };

    const getMachineErrorCount = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setMachineErrorLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(
                Constants.GETMACHINEERRORCOUNT, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    setMachineErrorLoading(false);
                    setMachineErrorCount(resp.hits.total.value);
                })
                .catch((error) => {
                    setMachineErrorLoading(false);
                });
        }
    };

    const prepareOrderAnomalies = (resp) => {
        let data = [];
        let obj = {};
        let headers = []; let headerResult = [];
        if (resp) {
            let buckets = resp.hits.hits;
            for (let i = 0; i < buckets.length; i++) {
                let source = buckets[i]._source;
                let incidentpath = `/IncidentDetails?alertType=queueAlert&client=${source.party_nm}&incidentId=${source.incident_id}&sysId=${source.incident_sys_id}&workspace=${props.workspace}&isQueue=${true}&appHostName=${source.app_host_machine_nm}&queueName=${source.queue_name}`;
                obj = {
                    id: (i + 1).toString(),
                    error: source.automata_info,
                    incidentNumber: source.incident_id ? <a href={incidentpath} target="_blank" rel="noreferrer">{source.incident_id}</a> : "",
                    assignedTo: source.assigned_to
                }
                for (const [key, value] of Object.entries(source.data)) {
                    headers.push({ key: key, header: key });
                    obj[key] = value;
                }
                headers.push(
                    {
                        key: 'error',
                        header: DashboardConstants.Error
                    },
                    {
                        key: 'incidentNumber',
                        header: DashboardConstants.IncidentNumber
                    },
                    // {
                    //     key: 'assignedTo',
                    //     header: DashboardConstants.AssignedTo
                    // }
                );
                data.push(obj);
            }
        }
        const map = new Map();
        for (const item of headers) {
            if (!map.has(item.key) && item.key !== '') {
                map.set(item.key, true);
                headerResult.push({ key: item.key, header: item.header });
            }
        }
        setOrderAnomaliesTableHeaders(headerResult)
        return data;
    };

    const getOrderAnomalies = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let formattedData = []; let keyword = "";
            setOrderAnomaliesLoading(true);
            let URL = SelectedView === "MachineError" ? Constants.GETORDERANOMALIESMACHINEERROR : Constants.GETORDERANOMALIESHUMANERROR;
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, automataName);
            callPostApi(URL, { "Content-Type": "application/json" }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareOrderAnomalies(resp);
                    if (resp && resp.hits && resp.hits.hits && resp.hits.hits[0] && resp.hits.hits[0]._source && resp.hits.hits[0]._source.key_kpi) {
                        keyword = resp.hits.hits[0]._source.key_kpi;
                    } else keyword = "Item";
                    setKeyword(keyword);
                    setOrderAnomaliesLoading(false);
                    setOrderAnomaliesData(formattedData);
                })
                .catch((error) => {
                    setKeyword("Item");
                    setOrderAnomaliesLoading(false);
                });
        }
    };

    const switchView = (e) => {
        setSelectedView(e.name);
    };

    return (
        <div className="top-margin dashboard processes-dashboard">
            <div className="dashboard-detail-container">

                <div className="title">
                    {DashboardConstants.ProcessesSummary}
                </div>
                <div className="breadcrumb">
                    <Breadcrumb noTrailingSlash>
                        {selectedNavItemArray.length && navMenu.length > 0 ?
                            selectedNavItemArray.map((item) => (
                                <BreadcrumbItem href="#">{item}</BreadcrumbItem>
                            ))
                            :
                            ''
                        }
                    </Breadcrumb>
                </div>
                {sideNavLoading ?
                    <div className="tile loading-container">
                        <InlineLoading
                            description={DashboardConstants.Loading}
                        />
                    </div>
                    :
                    <>
                        {navMenu.length > 0 ?
                            <div className="processes-container">
                                <div className="side-nav">
                                    <DashboardSideNavFilter reloadData={reloadData} navMenu={navMenu} selectedMenu={selectedMenu} />
                                </div>
                                <div className="container-wrapper">
                                    <div className="dashboard-roleContainer">
                                        <Summary title={DashboardConstants.ProcessesSummary} loading={processesSummaryLoading} summary={processesSummary} />
                                    </div>
                                    <div className="dashboard-charts-container">
                                        <section className="border-bottom">
                                            <div className="tile-view">
                                                <div className="report-container">
                                                    <DashboardLineChart
                                                        lineGraphData={orderProcessingData}
                                                        loading={orderProcessingLoading}
                                                        title={`${keyword} ${DashboardConstants.ProcessingTrend}`}
                                                        graphTitle={`${Pluralize(keyword)}`}
                                                    />
                                                </div>
                                                <div className="report-container">
                                                    <DashboardLineChart
                                                        lineGraphData={automationDowntimeData}
                                                        loading={automationDowntimeLoading}
                                                        title={DashboardConstants.AutomationDowntime}
                                                        graphTitle={DashboardConstants.Hours}
                                                        isPercentage={true}
                                                    />
                                                </div>
                                            </div>
                                        </section>
                                        <section className="graph-data-summary border-bottom">
                                            <div className="tile-table-container">
                                                <div className='summary-tile'><Summary title={DashboardConstants.ProcessesSummary} loading={processesSummaryLoading} summary={processesError} direction="column" /></div>
                                                <div className="table-container-anomaly">
                                                    <div className="title">
                                                        <div className="table-title">{`${keyword} ${DashboardConstants.Anomalies}`}</div>
                                                        <div className="table-toolbar">
                                                            <TableToolbar>
                                                                <TableToolbarContent>
                                                                    <ContentSwitcher onChange={switchView} className="content-switcher">
                                                                        <Switch name={'HumanError'} text={DashboardConstants.HumanError} />
                                                                        <Switch name={'MachineError'} text={DashboardConstants.MachineError} />
                                                                    </ContentSwitcher>
                                                                </TableToolbarContent>
                                                            </TableToolbar>
                                                        </div>
                                                    </div>
                                                    <div className='anomaly-table' >
                                                        <DashboardTable loading={orderAnomaliesLoading} rows={orderAnomaliesData} headers={orderAnomaliesTableHeaders}
                                                            showPagination={true} isSortable={true} />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            : <div className='no-data'>{DashboardConstants.NoDataAvailable}</div>}
                    </>
                }
            </div>
        </div>
    );
};

export default Processes;
